import React from 'react'
import {
  AlignItems,
  Box,
  Color,
  Display,
  FlexDirection,
  FontWeight,
  Icon,
  IconVariant,
  Text,
} from '@gousto-internal/citrus-react'

type DeliveryDetailCardProps = {
  iconName: 'calendar' | 'local_shipping'
  title: string
  children: React.ReactNode
}

export const DeliveryDetailCard = ({ iconName, title, children }: DeliveryDetailCardProps) => (
  <Box
    bg={Color.White}
    borderRadius={1.5}
    boxShadow="0 1px 6px rgba(0, 0, 0, 0.12)"
    paddingH={4}
    paddingV={4}
    flexGrow={1}
    flexBasis="0"
    minWidth="0"
    color={Color.ColdGrey_900}
    style={{ borderRadius: '6px' }}
  >
    <Box display={Display.Flex} alignItems={AlignItems.Center} gap={2} paddingBottom={2}>
      <Icon name={iconName} variant={IconVariant.Default} size={5} />
      <Text fontWeight={FontWeight.Bold}>{title}</Text>
    </Box>
    <Box display={Display.Flex} flexDirection={FlexDirection.Column} gap={1}>
      {children}
    </Box>
  </Box>
)
